import {
	vcpodeHttp as http,
} from "@/http";

import { serialize } from "./utils";

const get = async (data = {}) => {
    const params = serialize({ ...data });
    return http.get(`bff/testimonials${params}`);
}

const post = async (data) => http.post(`bff/testimonials`, data);

const put = async (testimonialId, data) => http.put(`bff/testimonials/${testimonialId}`, data);

const remove = async (testimonialId) => http.delete(`bff/testimonials/${testimonialId}`);

export const depoiments = {
    get,
    post,
    put,
    remove,
};
